// extracted by mini-css-extract-plugin
export default {"featuredPartnerContainer":"sqNU9HfQAPx9ApBy1I8P"};